import { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import '../styles/Admin.css';

const BACKEND_URL = 'https://api.comprapapaya.com';

// Helper reutilizable para alertas
const showAlert = {
  success: (message) => {
    return Swal.fire({
      icon: 'success',
      title: '¡Éxito!',
      text: message,
      confirmButtonColor: '#e91e63',
      confirmButtonText: 'Aceptar'
    });
  },
  error: (message) => {
    return Swal.fire({
      icon: 'error',
      title: 'Error',
      text: message,
      confirmButtonColor: '#e91e63',
      confirmButtonText: 'Aceptar'
    });
  },
  confirm: async (title, text) => {
    return await Swal.fire({
      icon: 'warning',
      title: title,
      text: text,
      showCancelButton: true,
      confirmButtonColor: '#e91e63',
      cancelButtonColor: '#757575',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });
  }
};

function Admin({ onLogout }) {
  // Estado para la sección activa
  const [activeSection, setActiveSection] = useState('categorias');

  const [services, setServices] = useState([]);

  const [reviews, setReviews] = useState([]);

  const [activeReservations, setActiveReservations] = useState([]);
  const [historyReservations, setHistoryReservations] = useState([]);
  const [loading, setLoading] = useState(true);

  const [serviceName, setServiceName] = useState('');
  const [serviceCategoryId, setServiceCategoryId] = useState('');
  const [servicePrice, setServicePrice] = useState('');
  const [editingServiceId, setEditingServiceId] = useState(null);

  const [clientName, setClientName] = useState('');
  const [serviceId, setServiceId] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [editingReservationId, setEditingReservationId] = useState(null);

  const [reservationsWithServices, setReservationsWithServices] = useState([]);

  const token = localStorage.getItem('token');

  const [categories, setCategories] = useState([]);
  const [categoryName, setCategoryName] = useState('');
  const [categoryPosition, setCategoryPosition] = useState(0);
  const [editingCategoryId, setEditingCategoryId] = useState(null);


  const cargarCategorias = async () => {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const res = await axios.get(`${BACKEND_URL}/categories`, config);
    setCategories(res.data);
  };

  useEffect(() => {
    cargarTodo();
    cargarCategorias();
  }, []);

  const cargarTodo = async () => {
    setLoading(true);
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
  
      const [servicesRes, reservationsRes, historyRes, reviewsRes] = await Promise.all([
        axios.get(`${BACKEND_URL}/services/public`),
        axios.get(`${BACKEND_URL}/reservations/active`, config),
        axios.get(`${BACKEND_URL}/reservations/history`, config),
        axios.get(`${BACKEND_URL}/reviews`, config),
      ]);
  
      const serviciosPlano = Object.values(servicesRes.data).flat();
  
      setServices(serviciosPlano);
      setReservationsWithServices(reservationsRes.data);
      setHistoryReservations(historyRes.data);
      setReviews(reviewsRes.data);
    } catch (err) {
      console.error(err);
      showAlert.error('Error cargando datos');
    }
    setLoading(false);
  };

  const guardarCategoria = async () => {
    if (!categoryName) {
      showAlert.error('El nombre de la categoría es requerido');
      return;
    }
  
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const payload = {
      name: categoryName,
      position: categoryPosition
    };
  
    try {
      if (editingCategoryId) {
        await axios.put(
          `${BACKEND_URL}/categories/${editingCategoryId}`,
          payload,
          config
        );
        showAlert.success('Categoría actualizada correctamente');
      } else {
        await axios.post(
          `${BACKEND_URL}/categories`,
          payload,
          config
        );
        showAlert.success('Categoría creada correctamente');
      }
  
      resetCategoryForm();
      cargarCategorias();
    } catch (err) {
      console.error(err);
      showAlert.error('Error guardando categoría');
    }
  };

  const resetCategoryForm = () => {
    setCategoryName('');
    setCategoryPosition(0);
    setEditingCategoryId(null);
  };

  const cambiarEstadoReview = async (id, status) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
  
      await axios.put(
        `${BACKEND_URL}/reviews/${id}/status`,
        { status },
        config
      );
  
      showAlert.success(
        status === 'aprobado'
          ? 'Reseña aprobada'
          : 'Reseña rechazada'
      );
  
      cargarTodo();
    } catch (err) {
      console.error(err);
      showAlert.error('Error cambiando estado');
    }
  };

  

  const cambiarEstadoCategoria = async (id, status) => {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    try {
      await axios.put(
        `${BACKEND_URL}/categories/${id}/status`,
        { status },
        config
      );
      showAlert.success(`Categoría ${status ? 'activada' : 'desactivada'} correctamente`);
      cargarCategorias();
    } catch (err) {
      console.error(err);
      showAlert.error('Error cambiando estado de categoría');
    }
  };

  const eliminarCategoria = async (id) => {
    const result = await showAlert.confirm(
      '¿Estás seguro?',
      'Esta acción no se puede deshacer'
    );

    if (!result.isConfirmed) return;

    const config = { headers: { Authorization: `Bearer ${token}` } };

    try {
      await axios.delete(`${BACKEND_URL}/categories/${id}`, config);
      showAlert.success('Categoría eliminada correctamente');
      cargarCategorias();
    } catch (err) {
      if (err.response?.status === 409) {
        showAlert.error('No se puede eliminar: tiene servicios asociados');
      } else {
        showAlert.error('Error eliminando categoría');
      }
    }
  };

  const guardarServicio = async () => {
    if (!serviceName || !servicePrice || !serviceCategoryId) {
      showAlert.error('Por favor completa todos los campos');
      return;
    }

    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };

      const payload = {
        name: serviceName,
        price: servicePrice,
        category_id: serviceCategoryId
      };

      if (editingServiceId) {
        await axios.put(
          `${BACKEND_URL}/services/${editingServiceId}`,
          payload,
          config
        );
        showAlert.success('Servicio actualizado correctamente');
      } else {
        await axios.post(
          `${BACKEND_URL}/services`,
          payload,
          config
        );
        showAlert.success('Servicio creado correctamente');
      }

      resetServiceForm();
      cargarTodo();
    } catch (err) {
      console.error(err);
      showAlert.error('Error guardando servicio');
    }
  };

  const editarServicio = (s) => {
    setEditingServiceId(s.id);
    setServiceName(s.name);
    setServicePrice(s.price);
    setServiceCategoryId(s.category_id);
  };

  const eliminarServicio = async (id) => {
    const result = await showAlert.confirm(
      '¿Eliminar servicio?',
      'Esta acción no se puede deshacer'
    );

    if (!result.isConfirmed) return;

    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      await axios.delete(`${BACKEND_URL}/services/${id}`, config);
      showAlert.success('Servicio eliminado correctamente');
      cargarTodo();
    } catch (err) {
      console.error(err);
      showAlert.error('Error eliminando servicio');
    }
  };

  const resetServiceForm = () => {
    setServiceName('');
    setServicePrice('');
    setServiceCategoryId('');
    setEditingServiceId(null);
  };

  const guardarReserva = async () => {
    if (!clientName || !serviceId || !date || !time) {
      showAlert.error('Por favor completa todos los campos');
      return;
    }
  
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
  
      const payload = {
        client_name: clientName,
        services: [Number(serviceId)],
        date,
        time
      };
  
      await axios.post(`${BACKEND_URL}/reservations`, payload, config);
  
      resetReservationForm();
      showAlert.success('Reserva creada correctamente');
      cargarTodo();
    } catch (err) {
      console.error(err);
      showAlert.error('Error guardando reserva');
    }
  };
  const editarReserva = (r) => {
    setEditingReservationId(r.id);
    setClientName(r.client_name);
    setServiceId(r.service_id);
    setDate(r.date);
    setTime(r.time);
  };

  const eliminarReserva = async (id) => {
    const result = await showAlert.confirm(
      '¿Eliminar reserva?',
      'Esta acción no se puede deshacer'
    );

    if (!result.isConfirmed) return;

    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      await axios.delete(`${BACKEND_URL}/reservations/${id}`, config);
      showAlert.success('Reserva eliminada correctamente');
      cargarTodo();
    } catch (err) {
      console.error(err);
      showAlert.error('Error eliminando reserva');
    }
  };

  const cambiarEstado = async (id, status) => {
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      await axios.put(`${BACKEND_URL}/reservations/${id}/status`, { status }, config);

      const statusText = status === 'atendido' ? 'aceptada' : 'cancelada';
      showAlert.success(`Reserva ${statusText} correctamente`);

      const [a, h] = await Promise.all([
        axios.get(`${BACKEND_URL}/reservations/active`, config),
        axios.get(`${BACKEND_URL}/reservations/history`, config),
      ]);
      
      setReservationsWithServices(a.data);
      setHistoryReservations(h.data);
    } catch (err) {
      console.error(err);
      showAlert.error('Error cambiando estado');
    }
  };

  const resetReservationForm = () => {
    setClientName('');
    setServiceId('');
    setDate('');
    setTime('');
    setEditingReservationId(null);
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <h3>Cargando panel admin...</h3>
      </div>
    );
  }

  // Función para obtener el conteo de cada sección
  const getCounts = () => ({
    categorias: categories.length,
    servicios: services.length,
    reservas: reservationsWithServices.length,
    historial: historyReservations.length,
    resenias: reviews.length,
  });

  const counts = getCounts();

  return (
    <div className="admin-container">
      <div className="admin-header">
        <div className="header-content">
          <h1>Panel de Administración</h1>
          <p className="header-subtitle">Gestiona tus servicios y reservas</p>
        </div>
        <button className="logout-btn" onClick={onLogout}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
          Cerrar sesión
        </button>
      </div>

      {/* NAVEGACIÓN POR PESTAÑAS */}
      <div className="tabs-navigation">
        <button 
          className={`tab-btn ${activeSection === 'categorias' ? 'active' : ''}`}
          onClick={() => setActiveSection('categorias')}
        >
          <div className="tab-content">
            <span className="tab-title">Categorías</span>
            <span className="tab-count">{counts.categorias}</span>
          </div>
        </button>

        <button 
          className={`tab-btn ${activeSection === 'servicios' ? 'active' : ''}`}
          onClick={() => setActiveSection('servicios')}
        >
          <div className="tab-content">
            <span className="tab-title">Servicios</span>
            <span className="tab-count">{counts.servicios}</span>
          </div>
        </button>

        <button 
          className={`tab-btn ${activeSection === 'reservas' ? 'active' : ''}`}
          onClick={() => setActiveSection('reservas')}
        >
          <div className="tab-content">
            <span className="tab-title">Reservas</span>
            <span className="tab-count">{counts.reservas}</span>
          </div>
        </button>

        <button 
          className={`tab-btn ${activeSection === 'historial' ? 'active' : ''}`}
          onClick={() => setActiveSection('historial')}
        >

          <div className="tab-content">
            <span className="tab-title">Historial</span>
            <span className="tab-count">{counts.historial}</span>
          </div>
        </button>


        <button 
          className={`tab-btn ${activeSection === 'resenias' ? 'active' : ''}`}
          onClick={() => setActiveSection('resenias')}
        >
          <div className="tab-content">
            <span className="tab-title">Reseñas</span>
            <span className="tab-count">{counts.resenias}</span>
          </div>
        </button>
      </div>

      {/* SECCIÓN CATEGORÍAS */}
      {activeSection === 'categorias' && (
        <div className="section-content">
          <div className="admin-card">
            <div className="card-header">
              <h2>Gestión de Categorías</h2>
              <span className="badge">{categories.length} total</span>
            </div>
          
            <div className="admin-form">
              <input
                placeholder="Nombre de la categoría"
                value={categoryName}
                onChange={e => setCategoryName(e.target.value)}
              />
          
              <input
                type="number"
                placeholder="Orden de visualización"
                value={categoryPosition}
                onChange={e => setCategoryPosition(Number(e.target.value))}
              />
          
              <button className="btn-primary" onClick={guardarCategoria}>
                {editingCategoryId ? '✓ Actualizar' : '+ Crear Categoría'}
              </button>
          
              {editingCategoryId && (
                <button className="btn-secondary" onClick={resetCategoryForm}>
                  Cancelar
                </button>
              )}
            </div>
          
            <div className="table-wrapper">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Orden</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="empty-row">
                        No hay categorías creadas
                      </td>
                    </tr>
                  ) : (
                    categories.map(c => (
                      <tr key={c.id}>
                        <td><strong>{c.name}</strong></td>
                        <td>{c.position}</td>
                        <td>
                          <span className={`status-badge ${c.status ? 'active' : 'inactive'}`}>
                            {c.status ? '● Activa' : '○ Inactiva'}
                          </span>
                        </td>
                        <td className="table-actions">
                          <button 
                            className="btn-icon btn-edit"
                            onClick={() => {
                              setEditingCategoryId(c.id);
                              setCategoryName(c.name);
                              setCategoryPosition(c.position);
                            }}
                            title="Editar"
                          >
                            ✎
                          </button>
          
                          <button 
                            className={`btn-icon ${c.status ? 'btn-deactivate' : 'btn-activate'}`}
                            onClick={() => cambiarEstadoCategoria(c.id, c.status ? 0 : 1)}
                            title={c.status ? 'Desactivar' : 'Activar'}
                          >
                            {c.status ? '✕' : '✓'}
                          </button>
          
                          <button 
                            className="btn-icon btn-delete"
                            onClick={() => eliminarCategoria(c.id)}
                            title="Eliminar"
                          >
                            🗑
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* SECCIÓN SERVICIOS */}
      {activeSection === 'servicios' && (
        <div className="section-content">
          <div className="admin-card">
            <div className="card-header">
              <h2>Gestión de Servicios</h2>
              <span className="badge">{services.length} total</span>
            </div>
          
            <div className="admin-form">
              <input
                placeholder="Nombre del servicio"
                value={serviceName}
                onChange={e => setServiceName(e.target.value)}
              />
          
              <input
                type="number"
                placeholder="Precio (S/)"
                value={servicePrice}
                onChange={e => setServicePrice(e.target.value)}
              />
          
              <select
                value={serviceCategoryId}
                onChange={e => setServiceCategoryId(e.target.value)}
              >
                <option value="">Selecciona una categoría</option>
                {categories.map(c => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </select>
          
              <button className="btn-primary" onClick={guardarServicio}>
                {editingServiceId ? '✓ Actualizar' : '+ Crear Servicio'}
              </button>
          
              {editingServiceId && (
                <button className="btn-secondary" onClick={resetServiceForm}>
                  Cancelar
                </button>
              )}
            </div>
          
            <div className="table-wrapper">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Servicio</th>
                    <th>Precio</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {services.length === 0 ? (
                    <tr>
                      <td colSpan="3" className="empty-row">
                        No hay servicios creados
                      </td>
                    </tr>
                  ) : (
                    services.map(s => (
                      <tr key={s.id}>
                        <td><strong>{s.name}</strong></td>
                        <td className="price-cell">S/ {s.price}</td>
                        <td className="table-actions">
                          <button 
                            className="btn-icon btn-edit"
                            onClick={() => editarServicio(s)}
                            title="Editar"
                          >
                            ✎
                          </button>
                          <button 
                            className="btn-icon btn-delete"
                            onClick={() => eliminarServicio(s.id)}
                            title="Eliminar"
                          >
                            🗑
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* SECCIÓN RESERVAS */}
      {activeSection === 'reservas' && (
        <div className="section-content">
          {/* CREAR RESERVA */}
          <div className="admin-card">
            <div className="card-header">
              <h2>Nueva Reserva</h2>
            </div>

            <div className="admin-form">
              <input 
                placeholder="Nombre del cliente" 
                value={clientName} 
                onChange={e => setClientName(e.target.value)} 
              />
              
              <select value={serviceId} onChange={e => setServiceId(e.target.value)}>
                <option value="">Selecciona un servicio</option>
                {services.map(s => (
                  <option key={s.id} value={s.id}>
                    {s.name} - S/ {s.price}
                  </option>
                ))}
              </select>
              
              <input 
                type="date" 
                value={date} 
                onChange={e => setDate(e.target.value)} 
              />
              
              <input 
                type="time" 
                value={time} 
                onChange={e => setTime(e.target.value)} 
              />
              
              <button className="btn-primary" onClick={guardarReserva}>
                {editingReservationId ? '✓ Actualizar' : '+ Crear Reserva'}
              </button>
              
              {editingReservationId && (
                <button className="btn-secondary" onClick={resetReservationForm}>
                  Cancelar
                </button>
              )}
            </div>
          </div>

          {/* RESERVAS ACTIVAS */}
          <div className="admin-card">
            <div className="card-header">
              <h2>Reservas Activas</h2>
              <span className="badge">{reservationsWithServices.length} pendientes</span>
            </div>

            <div className="table-wrapper">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Cliente</th>
                    <th>Servicios</th>
                    <th>Fecha</th>
                    <th>Hora</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {reservationsWithServices.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="empty-row">
                        No hay reservas activas
                      </td>
                    </tr>
                  ) : (
                    reservationsWithServices.map(r => (
                      <tr key={r.id}>
                        <td><strong>{r.client_name}</strong></td>
                        <td>
                          {(() => {
                            const service = services.find(s => s.id === r.service_id);
                            return service ? (
                              <>
                                {service.name} – S/ {service.price}
                              </>
                            ) : 'N/A';
                          })()}
                        </td>
                        <td>{r.date}</td>
                        <td>{r.time}</td>
                        <td>
                          <span className="status-badge pending">● {r.status}</span>
                        </td>
                        <td className="table-actions">
                          <button 
                            className="btn-icon btn-success"
                            onClick={() => cambiarEstado(r.id, 'atendido')}
                            title="Aceptar"
                          >
                            ✓
                          </button>
                          <button 
                            className="btn-icon btn-cancel"
                            onClick={() => cambiarEstado(r.id, 'cancelado')}
                            title="Cancelar"
                          >
                            ✕
                          </button>
                          <button 
                            className="btn-icon btn-delete"
                            onClick={() => eliminarReserva(r.id)}
                            title="Eliminar"
                          >
                            🗑
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* SECCIÓN HISTORIAL */}
      {activeSection === 'historial' && (
        <div className="section-content">
          <div className="admin-card">
            <div className="card-header">
              <h2>Historial de Reservas</h2>
              <span className="badge">{historyReservations.length} completadas</span>
            </div>
          
            <div className="table-wrapper">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Cliente</th>
                    <th>Servicio</th>
                    <th>Fecha</th>
                    <th>Hora</th>
                    <th>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {historyReservations.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="empty-row">
                        No hay historial de reservas
                      </td>
                    </tr>
                  ) : (
                    historyReservations.map(r => {
                      const s = services.find(x => x.id === r.service_id);
                      return (
                        <tr key={r.id}>
                          <td><strong>{r.client_name}</strong></td>
                          <td>{s?.name || 'N/A'}</td>
                          <td>{r.date}</td>
                          <td>{r.time}</td>
                          <td>
                            <span className={`status-badge ${r.status === 'atendido' ? 'completed' : 'cancelled'}`}>
                              {r.status === 'atendido' ? '✓ Atendido' : '✕ Cancelado'}
                            </span>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
     {activeSection === 'resenias' && (
        <div className="section-content">
          <div className="admin-card">
            <div className="card-header">
              <h2>Reseñas de Clientes</h2>
            </div>
      
            <div className="table-wrapper">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Email</th>
                    <th>Comentario</th>
                    <th>Rating</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {reviews.map(r => (
                    <tr key={r.id}>
                      <td>{r.name}</td>
                      <td>{r.email}</td>
                      <td>{r.comment}</td>
                      <td>{'★'.repeat(r.rating)}</td>
                      <td>{r.status}</td>
                      <td>
                        <button onClick={() => cambiarEstadoReview(r.id, 'aprobado')}>
                          ✓
                        </button>
                        <button onClick={() => cambiarEstadoReview(r.id, 'rechazado')}>
                          ✕
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      
    </div>
  );
}

export default Admin;